import React from 'react';
import { ChannelLogEntry } from '../../api/channels';
import { colors, spacing, typography, typographyFlat, borderRadius } from '../../styles/tokens';
import { formatInstant } from '../../utils/datetime';

interface SyncLogsTableProps {
  logs: ChannelLogEntry[];
  emptyMessage?: string;
}

export const SyncLogsTable: React.FC<SyncLogsTableProps> = ({ logs, emptyMessage = 'No logs yet' }) => {
  if (!logs.length) {
    return (
      <div
        style={{
          padding: spacing.lg,
          border: `1px solid ${colors.border}`,
          borderRadius: borderRadius.md,
          backgroundColor: colors.surface,
          color: colors.textSecondary,
        }}
      >
        {emptyMessage}
      </div>
    );
  }

  return (
    <div style={{ overflowX: 'auto' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr style={{ backgroundColor: colors.surface, borderBottom: `2px solid ${colors.border}` }}>
            <th style={thStyle}>Time</th>
            <th style={thStyle}>Level</th>
            <th style={thStyle}>Message</th>
          </tr>
        </thead>
        <tbody>
          {logs.map((log) => (
            <tr key={log.id} style={{ borderBottom: `1px solid ${colors.border}` }}>
              <td style={tdStyle}>{formatInstant(log.timestamp, 'time unknown')}</td>
              <td style={{ ...tdStyle, color: getLevelColor(log.level || 'info') }}>{log.level || 'info'}</td>
              <td style={tdStyle}>{log.message}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const thStyle = {
  textAlign: 'left' as const,
  padding: spacing.md,
  fontSize: typography.body.fontSize,
  fontWeight: typographyFlat.fontWeight.semibold,
  color: colors.text,
};

const tdStyle = {
  padding: spacing.md,
  fontSize: typography.body.fontSize,
  color: colors.text,
};

const getLevelColor = (level: ChannelLogEntry['level']) => {
  switch (level) {
    case 'error':
      return colors.error;
    case 'warning':
      return colors.warning;
    default:
      return colors.text;
  }
};
